import { IconComponentStyled } from '@procurify/ui'
import styled from 'styled-components'

export const BreadcrumbsItemStyled = styled.li`
  display: inline-flex;
  align-items: center;

  ${IconComponentStyled} {
    margin: 0 ${(props) => props.theme.space.medium};
  }
`
